<template>
  <div v-if="hasData" class="summary-panel">
    <div class="summary-grid">
      <div v-for="key in displayKeys" :key="key" class="summary-item">
        <label>{{ formatLabel(key) }}:</label>
        <span>{{ formatValue(summary[key]) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryPanel',
  props: {
    summary: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    displayKeys() {
      if (!this.summary) return []
      return Object.keys(this.summary).filter(key => {
        const val = this.summary[key]
        // Hide null, undefined, empty arrays
        if (val === null || val === undefined) return false
        if (Array.isArray(val) && val.length === 0) return false
        return true
      })
    },
    hasData() {
      return this.displayKeys.length > 0
    }
  },
  methods: {
    formatLabel(key) {
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim()
    },
    formatValue(value) {
      if (value === null || value === undefined) return '-'
      if (Array.isArray(value)) return value.join(', ')
      if (typeof value === 'object') return JSON.stringify(value)
      if (typeof value === 'number') {
        // Format very large or very small numbers
        if (Math.abs(value) > 1e15 || (value !== 0 && Math.abs(value) < 1e-6)) {
          return value.toExponential(4)
        }
        // Round to reasonable precision
        return Number.isInteger(value) ? value : parseFloat(value.toFixed(6))
      }
      return value
    }
  }
}
</script>

<style scoped lang="scss">
.summary-panel {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;

  h5 {
    font-size: 13px;
    font-weight: 600;
    color: #666;
    margin-bottom: 8px;
  }

  .summary-grid {
    display: flex;
    gap: 15px;

    .summary-item {
      label {
        font-weight: 600;
        margin-right: 8px;
        font-size: 13px;
        color: #555;
      }

      span {
        font-size: 13px;
        color: #333;
      }
    }
  }
}
</style>
